<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div style="display: inline-block" v-for="(item , index) of formdata" :key="index">
					<Commondropdownlist ref="productAndref" :widths="item.widths" :options="item.options"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" :qhide="false" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Productstandardtable :tableData="tableData" :total="total" @CRExport="CRExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Productstandardtable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Productstandardtable from './components/productstandardtable.vue'
	import formdata from './fromData/formdata'
	import utils from '../../../common/utils'
	import {
		InvStandardCostList,
		InvStandardCostExport,
		InventoryClassList,
		HospitalGetHospitalType
	} from '@/api/home'
	import {
		GetHelperLevel3,
	} from "@/api/newsapi";
	export default {
		components: {
			Commondropdownlist,
			Productstandardtable,
			Dialog,
			CommonBtngroup
		},
		data() {
			return {
				tableData: [],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				dialogVisibles: false,
				showorhide: true,
				formdata: [

				],
				from: {
					InvAddCode: "",
					InvName: "",
					ValiDate1: "",
					ValiDate2: "",
					StandardCost1: "",
					StandardCost2: "",
					Enabled: null,
					CreateTime1: "",
					CreateTime2: "",
					InvClass: "",
					LEVEL3: "",
				}
			}
		},
		mounted() {
			this.formdata = JSON.parse(JSON.stringify(formdata))
			this.invStandardCostList()
			this.inventoryClassList();
			this.getHelperL3();
			// this.inventoryClassList()
			// this.hospitalGetHospitalType()
		},
		methods: {
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[6].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[6].options.push(obj)
					})
				}
			},
			//获取l3数据
			async getHelperL3() {
				let {
					code,
					data
				} = await GetHelperLevel3({});
				if (code == 0) {
					this.formdata[7].options = [];
					data.map((item, index) => {
						this.formdata[7].options.push({
							key: item.value,
							value: item.key,
						});
					});
				}
			},
			// 列表
			async invStandardCostList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await InvStandardCostList({
					InvAddCode: this.from.InvAddCode,
					InvName: this.from.InvName,
					ValiDate1: this.from.ValiDate1,
					ValiDate2: this.from.ValiDate2,
					StandardCost1: this.from.StandardCost1,
					StandardCost2: this.from.StandardCost2,
					Enabled: this.from.Enabled == "" ? null : this.from.Enabled,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					InvClass: this.from.InvClass,
					LEVEL3: this.from.LEVEL3,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
				}
				loading.close();
			},
			// 导出
			async invStandardCostExport() {
				let resexprot = await InvStandardCostExport({
					InvAddCode: this.from.InvAddCode,
					InvName: this.from.InvName,
					ValiDate1: this.from.ValiDate1,
					ValiDate2: this.from.ValiDate2,
					StandardCost1: this.from.StandardCost1,
					StandardCost2: this.from.StandardCost2,
					Enabled: this.from.Enabled == "" ? null : this.from.Enabled,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					InvClass: this.from.InvClass,
					LEVEL3: this.from.LEVEL3,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					//console.log(resexprot);
					if (resexprot.code == 999) {
						this.$message({
							type: "warning",
							message: resexprot.message
						})
					}
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot.data, `产品标准货值调整${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			CRExport() {
				this.invStandardCostExport()
			},
			async hospitalGetHospitalType() {
				let {
					data,
					code
				} = await HospitalGetHospitalType({})
				if (code == 0) {
					this.formdata[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						this.formdata[3].options.push(obj)
					})
				}
			},
			reset() {
				this.$refs.productAndref.map((item, index) => {
					if (index == 2 || index == 5) {
						item.startTime = ""
						item.endTime = ""
					}
					if (index == 3) {
						item.modelvalueleft = undefined
						item.modelvalueright = undefined
					}
					item.modelvalue = ""
				})
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			hide() {
				this.showorhide = false

			},
			showclick() {
				this.showorhide = true
			},
			select() {
				// 处理异常（折叠搜索框）
				this.pageindex = 1
				try {
					this.from.InvAddCode = this.$refs.productAndref[0].modelvalue
					this.from.InvName = this.$refs.productAndref[1].modelvalue
					this.from.ValiDate1 = this.$refs.productAndref[2].startTime
					this.from.ValiDate2 = this.$refs.productAndref[2].endTime
					this.from.StandardCost1 = this.$refs.productAndref[3].modelvalueleft
					this.from.StandardCost2 = this.$refs.productAndref[3].modelvalueright
					this.from.Enabled = this.$refs.productAndref[4].modelvalue
					this.from.CreateTime1 = this.$refs.productAndref[5].startTime
					this.from.CreateTime2 = this.$refs.productAndref[5].endTime
					this.from.InvClass = this.$refs.productAndref[6].modelvalue
					this.from.LEVEL3 = this.$refs.productAndref[7].modelvalue
					this.invStandardCostList()
				} catch (error) {
					this.invStandardCostList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.invStandardCostList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.invStandardCostList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 80px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 5px;
		width: 281px;
		height: 80px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
		z-index: 19;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>